(function () {
	const collapsibleContent = () => {
		$(".collapsible-content-v2").each(function () {
			const $section = $(this);

			$section.find(".collapsible-content-v2-summary").eq(0).addClass("active");

			$section.find(".collapsible-content-v2-summary").off("click").on("click", function () {
				const $summary = $(this);
				const $content = $summary.siblings(".collapsible-content-v2-item__content");

				if (!$summary.hasClass("active")) {
					$section.find(".collapsible-content-v2-summary.active").removeClass("active");
					$section.find(".collapsible-content-v2-item__content").stop().slideUp(300);

					$summary.addClass("active");
					$content.stop().slideDown(300);
				} else {
					$summary.removeClass("active");
					$content.stop().slideUp(300);
				}
			});
		});
	};

	collapsibleContent();

	document.addEventListener("shopify:section:load", function () {
		setTimeout(() => {
			collapsibleContent();
		}, 100);
	});
})();
